module.exports = __webpack_public_path__ + "static/img/下载.597315a2.png";